import { defineMeta } from '@/registry/types';

export const skeletonMeta = defineMeta({
  name: 'Skeleton',
  level: 'atom',
  category: 'feedback',
  classification: 'themed-mui',
  description: 'Loading placeholder that mimics content shape. Themed MUI Skeleton.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Skeleton',
  muiDocs: 'https://mui.com/material-ui/react-skeleton/',
  a2uiEquivalent: 'Skeleton',
  importPath: '@/atoms/Skeleton',
  optionalProps: ['variant', 'width', 'height', 'animation'],
  supportedStates: ['pulse', 'wave', 'loading'],
  designTokens: ['colors', 'radius'],
  accessibility: ['Mark loading regions with aria-busy; announce when content loads.'],
  usageExamples: ['<Skeleton variant="rectangular" height={120} />'],
  antiPatterns: ['Do not leave skeletons visible after data has loaded.'],
  llmSafe: true,
  whenToUse: ['Initial data loading states'],
  whenNotToUse: ['Empty states (use EmptyState)'],
});

export default skeletonMeta;
